import React, {useState, useEffect} from 'react';
import {InputsFormularioAdmin} from './InputsFormularioAdmin';
import Checkbox from '@mui/material/Checkbox';
import {Dropdown} from '../varios/Dropdown';
import {TipoServiciosEmpresaAdmin} from './TipoServiciosEmpresaAdmin';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import axios from 'axios';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useNavigate} from 'react-router-dom';
import {animateScroll as scroll} from 'react-scroll';

export const FormularioEmpresaAdmin = (props) => {
	/* Destructuring the props object. */
	const {guardarCambios, borrarCuenta, setPantallaPerfil, idEmpresa, atras, registroEmpresa} =
		props;

	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Creating a state variable called CategoriasPosibles and a function to update it called
    setCategoriasPosibles. */
	const [CategoriasPosibles, setCategoriasPosibles] = useState([]);

	/* Creating a state variable called ServiciosPosibles and a function to update it called
    setServiciosPosibles. */
	const [ServiciosPosibles, setServiciosPosibles] = useState([]);

	/* Creating a state variable called ErroresFormulario and a function to update it called
    setErroresFormulario. */
	const [ErroresFormulario, setErroresFormulario] = useState([]);

	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	/* Declaring a variable called IsDisabled and setting it to false. */
	const [IsDisabled, setIsDisabled] = useState(false);

	/* Using the useNavigate hook to navigate to a different page. */
	const navigate = useNavigate();

	const definirServicios = () => {
		/* Making a request to the server and getting a list of serivices. */
		axios({
			method: 'get',
			url: window.ipdirection + 'servicioEmpresaAdmin/?select=' + idEmpresa,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			let listaAxu2 = [];
			/* Mapping the response.data and pushing it into an aray. */
			response.data.map((servicioEmpresa) => {
				listaAxu2.push({
					id: servicioEmpresa.id,
					prestadorServicios_id: servicioEmpresa.prestadorServicios_id,
					servicio_id: {
						id: servicioEmpresa.servicio_id.id,
						nombre: servicioEmpresa.servicio_id.nombre,
						categoria_id: {
							id: servicioEmpresa.servicio_id.categoria_id.id,
							nombre: servicioEmpresa.servicio_id.categoria_id.nombre,
						},
					},
					precioMin: servicioEmpresa.precioMin,
					horasMin: servicioEmpresa.horasMin,
					estado: true,
					status: servicioEmpresa.estado,
				});
			});
			setServiciosPosibles(listaAxu2);
		});
	};

	const definirCategorias = () => {
		/* Making a request to the server and getting a list of categories. */
		axios({
			method: 'get',
			url: window.ipdirection + 'categoriaEmpresaAdmin/?select=' + idEmpresa,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			let listaAxu2 = [];
			/* Mapping the response.data and pushing it into an array. */
			response.data.map((categoriaEmpresa) => {
				listaAxu2.push({
					id: categoriaEmpresa.id,
					empresa_id: categoriaEmpresa.empresa_id,
					categoria_id: {
						id: categoriaEmpresa.categoria_id.id,
						nombre: categoriaEmpresa.categoria_id.nombre,
					},
					status: categoriaEmpresa.estado,
					estado: true,
				});
			});
			setCategoriasPosibles(listaAxu2);
		});
	};

	/* Calling the functions definirServicios() and definirCategorias() when the component is mounted. */
	useEffect(() => {
		/* Calling the scrollToTop() method on the scroll object. */
		scroll.scrollToTop();
		getDatEmpresaAdmin();
		/* Defining the services and categories. */
		definirServicios();
		definirCategorias();
	}, []);

	/**
	 * If the email address is not in the form of a string, return false. If the email address is in
	 * the form of a string, return true.
	 * @returns A boolean value.
	 */
	const emailErroneo = (email) => {
		var validator = require('email-validator');
		return validator.validate(email);
	};

	/**
	 * If the postal code is not 5 digits, then return false.
	 * @returns The function codigoPostalErroneo is being returned.
	 */
	const codigoPostalErroneo = (postalCode) => {
		/* The above code is a regular expression that checks if a string is 5 digits long. */
		var pattern = /^\d{5}$/;
		/* The above code is checking if the postal code is in the correct format. */
		return pattern.test(postalCode);
	};

	/**
	 * It returns true if the string is a valid Spanish phone number, and false otherwise.
	 * @returns A boolean value.
	 */
	const telefonoErroneo = (telefono) => {
		/* A regular expression that checks if a phone number is valid. */
		var pattern = /^(\+34|0034|34)?[6789]\d{8}$/;
		/* Checking if the phone number is valid. */
		return pattern.test(telefono);
	};

	/**
	 * If the length of the string is greater than 4, return true, otherwise return false.
	 * @returns const datosVacio = (dato) => {
	 *         return dato.length > 4
	 *     }
	 */
	const datosVacio = (dato) => {
		return dato.length > 4;
	};

	/**
	 * "If the password and the repeated password are not the same, push the error message to the list
	 * of errors, if the password is less than 10 characters or the password is wrong, push the error
	 * message to the list of errors, if the email is wrong, push the error message to the list of
	 * errors, if the postal code is wrong, push the error message to the list of errors, if the phone
	 * number is wrong, push the error message to the list of errors, if the name of the company is
	 * empty, push the error message to the list of errors, if the name of the contact is empty, push
	 * the error message to the list of errors, if the last name of the contact is empty, push the
	 * error message to the list of errors, if the address is empty, push the error message to the list
	 * of errors, if the company's website is empty, push the error message to the list of errors, if
	 * the list of errors is and if it list of error don`t have errors, create user else (Salta modal de errores)
	 */
	const comprobarDatos = () => {
		let listaErrores = [];
		/*
       /* *|MARKER_CURSOR|* */

		/* Checking if the email is valid. */
		if (!emailErroneo(empresa.emailEmpresa)) {
			listaErrores.push('El email introducido es erróneo');
		}

		/* Checking if the postal code is correct. */
		if (!codigoPostalErroneo(empresa.codigoPostal)) {
			listaErrores.push('El código postal introducido es erróneo');
		}

		/* Checking if the phone number is valid. */
		if (!telefonoErroneo(empresa.telefono)) {
			listaErrores.push('El teléfono introducido es erróneo');
		}

		/* Checking if the value of the field is empty. */
		if (!datosVacio(empresa.nombreEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo prestador de servicios');
		}

		/* Checking if the value of the variable empresa.nombreContactoEmpresa is empty. */
		if (!datosVacio(empresa.nombreContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo nombre contacto');
		}

		/* Checking if the value of the input field is empty. */
		if (!datosVacio(empresa.apellidosContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo apellidos');
		}

		/* Checking if the value of the variable empresa.direccion is empty. */
		if (!datosVacio(empresa.direccion)) {
			listaErrores.push('Debe introducir un valor válido en el campo dirección');
		}

		/* Checking if the value of the webEmpresa is empty. */
		if (!datosVacio(empresa.webEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo web Empresa');
		}
		/* Checking if the list of errors is empty. If it is empty, it will create a user. If it is not
        empty, it will set the errors in the form and set the modal errors to true. */
		if (listaErrores.length === 0) {
			crearUsuario();
			/* Creating a new user. */
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
			setModalErrores(true);
		}
	};

	/**
	 * It takes the data from the form and sends it to the backend to update the user.
	 */
	const updateUser = () => {
		let data = {
			username: empresa.nombreEmpresa,
			email: empresa.emailEmpresa,
		};
		axios({
			method: 'patch',
			url: window.ipdirection + 'usuarioByAdmin/' + empresa.usuario.id + '/',
			data: {
				...data,
			},
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Definir categorias
			modificarCategorias();
			atras();
		});
	};

	const modificarCategorias = () => {
		CategoriasPosibles.map((categoria) => {
			categoria.estado ? activarCategoria(categoria) : eliminarCategoria(categoria);
		});
		modificarServicios();
	};

	const activarCategoria = (categoria) => {
		axios({
			method: 'patch',
			url: window.ipdirection + 'categoriaEmpresaAdmin/' + categoria.id + '/',
			data: {
				estado: 'activo',
			},
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				setErroresFormulario(['Error al activar la categoria : ' + categoria.nombre]);
				setModalErrores(true);
			});
	};

	const eliminarCategoria = (categoria) => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'categoriaEmpresaAdmin/' + categoria.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				setErroresFormulario(['Error al eliminar la categoria : ' + categoria.nombre]);
				setModalErrores(true);
			});
	};

	const modificarServicios = () => {
		// obtenemos las categorias activas
		axios({
			method: 'get',
			url: window.ipdirection + 'categoriaEmpresaAdmin/?select=' + idEmpresa,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {
				estado: 'activo',
			},
		}).then((response) => {
			let listaCategoriasActivas = [];
			/* Mapping the response.data and pushing it into an array. */
			CategoriasPosibles.map((categoriaEmpresa) => {
				categoriaEmpresa.estado === true &&
					listaCategoriasActivas.push(categoriaEmpresa.categoria_id.nombre);
			});
			console.log(listaCategoriasActivas);
			enviarServicios(listaCategoriasActivas);
		});
	};

	const enviarServicios = (listaCategoriasActivas) => {
		ServiciosPosibles.map((servicio) => {
			console.log(listaCategoriasActivas.includes(servicio.servicio_id.categoria_id.nombre));
			if (
				servicio.estado === false ||
				listaCategoriasActivas.includes(servicio.servicio_id.categoria_id.nombre) === false
			) {
				eliminarServicio(servicio);
				console.log('entra elimina: ', servicio.servicio_id.nombre);
			} else {
				console.log('entra modifica: ', servicio.servicio_id.nombre);
				activarServicio(servicio);
			}
		});
	};
	const activarServicio = (servicio) => {
		axios({
			method: 'patch',
			url: window.ipdirection + 'servicioEmpresaAdmin/' + servicio.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {
				estado: 'activo',
			},
		})
			.then((response) => {})
			.catch((error) => {
				setErroresFormulario([
					'Error al modificar el servicio : ' + servicio.servicio_id.nombre,
				]);
				setModalErrores(true);
			});
	};

	const eliminarServicio = (servicio) => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'servicioEmpresaAdmin/' + servicio.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				setErroresFormulario([
					'Error al eliminar el servicio : ' + servicio.servicio_id.nombre,
				]);
				setModalErrores(true);
			});
	};

	const crearUsuario = () => {
		let data = {
			nombreEmpresa: empresa.nombreEmpresa,
			nombreContactoEmpresa: empresa.nombreContactoEmpresa,
			apellidosContactoEmpresa: empresa.apellidosContactoEmpresa,
			telefono: empresa.telefono,
			direccion: empresa.direccion,
			codigoPostal: empresa.codigoPostal,
			webEmpresa: empresa.webEmpresa,
			emailEmpresa: empresa.emailEmpresa,
			tamañoEmpresa: empresa.tamañoEmpresa,
			shareCare: empresa.shareCare,
			descripcionEmpresa: empresa.descripcionEmpresa,
			notasEmpresa: empresa.notasEmpresa,
			estado: 'activo',
		};
		axios({
			method: 'patch',
			url: window.ipdirection + 'prestadorServiciosAdmin/' + idEmpresa + '/',
			data: {
				...data,
			},
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				// Nos logeamos como empresa
				// para meter en el usuario los datos de la empresa
				updateUser();
				// HACER SUBCONSULTA PARA EL USUARIO
				// añadimos y enviamos las categorias que se ha selecionado
			})
			.catch((error) => {
				/* A catch block that is catching an error. */
				// Añadimos los errores al modal
				let listaErrores = [];
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};

	const getDatEmpresaAdmin = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServiciosAdmin/' + idEmpresa + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			// Introduciomos los datos del presatador de servicios al usuario
			setEmpresa(response.data);
		});
	};

	const [empresa, setEmpresa] = useState({
		idEmpresa: idEmpresa,
		nombreEmpresa: 'nombreEmpresa',
		nombreContactoEmpresa: 'nombreContactoEmpresa',
		apellidosContactoEmpresa: 'apellidosContactoEmpresa',
		constraseña: 'constraseña',
		repitaConstraseña: 'repitaConstraseña',
		telefono: '666666666',
		direccion: 'direccion',
		codigoPostal: 'codigoPostal',
		webEmpresa: 'webEmpresa',
		emailEmpresa: 'emailEmpresa',
		tamañoEmpresa: '0',
		shareCare: false,
		descripcionEmpresa: 'descripcionEmpresa',
		notasEmpresa: 'notasEmpresa',
	});

	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChange = (e) => {
		const {name, value} = e.target;
		setEmpresa({
			...empresa,
			[name]: value,
		});
	};
	/**
	 * The function takes an event as an argument, and then sets the state of the component to the
	 * value of the event
	 */
	const handleChangeTamañoEmpresa = (event) => {
		const min = 1;
		const max = 1000000;
		/* Setting the value of the input field to the value of the state. */
		const value = Math.max(min, Math.min(max, Number(event.target.value)));
		setEmpresa({
			...empresa,
			tamañoEmpresa: value,
		});
	};

	/**
	 * A function that changes the state of the variable "shareCare" to the opposite of what it was.
	 */
	const filtroShareCare = () => {
		/* Setting the state of the empresa object. */
		setEmpresa({
			...empresa,
			shareCare: !empresa.shareCare,
		});
	};
	/**
	 * If the id of the category is the same as the id of the category that was clicked, then change
	 * the status of the category to the opposite of what it was before.
	 */
	const cambiarCategoria = (id) => {
		let listaAxu = [];
		/* Mapping through the array of objects and checking if the id of the object is equal to the id
        passed in the function. If it is, it is changing the status of the object. */
		if (IsDisabled) {
			CategoriasPosibles.map((categoria) => {
				categoria.id === id && (categoria.estado = !categoria.estado);
				listaAxu.push(categoria);
			});
			setCategoriasPosibles(listaAxu);
		}
	};

	/**
	 * If the id of the service is the same as the id of the service that was clicked, then change the
	 * state of the service to the opposite of what it was before.
	 */
	const cambiarEstadoServ = (id) => {
		let listaAxu = [];
		/* Mapping through the array and checking if the id is equal to the id passed in. If it is, it
        is changing the state of the object. */
		ServiciosPosibles.map((serv) => {
			serv.id === id && (serv.estado = !serv.estado);
			listaAxu.push(serv);
		});
		setServiciosPosibles(listaAxu);
	};

	return (
		<>
			<div className='formularioUsuario'>
				<div className='buttons-Form-Empresa-Admin'>
					<div
						className='buttonAtrasFormularioUsuario'
						onClick={() => atras()}
					>
						Atrás
					</div>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setIsDisabled(!IsDisabled)}
						>
							<b>Modificar</b>
						</div>
					</div>
				</div>
				<div className='contentFormularioUsuario'>
					<div className='fotoUser'>
						<div className='centrador'>
							<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
						</div>
						<div className='centrador nombreID'>
							<div>
								<div className='centrador nombreUsuarioForm'>
									{empresa.nombreEmpresa}
								</div>
								{/*<div className='IDUsuario'><b>ID : </b>
                                {
                                    (registroEmpresa)
                                        ? <p>-------</p>
                                        : idEmpresa
                                }
                            </div>*/}
							</div>
						</div>
					</div>
					<InputsFormularioAdmin
						empresa={empresa}
						handleInpuntChange={handleInpuntChange}
						handleChangeTamañoEmpresa={handleChangeTamañoEmpresa}
						filtroShareCare={filtroShareCare}
						isDisabled={!IsDisabled}
					/>
					<div className='content-labelDatoFormUsu'>
						<div className='labelDatoFormUsu'>Categorias Solicitadas</div>
						<div className='categoriasFormRegistroEmpresa'>
							{CategoriasPosibles.map((categoria, index) => (
								<div
									className='formCategorias'
									key={index}
								>
									<div className='centrador'>{categoria.categoria_id.nombre}</div>
									<Checkbox
										defaultChecked
										checked={categoria.estado}
										onChange={() => cambiarCategoria(categoria.id)}
										sx={{
											color: '23C290',
											'&.Mui-checked': {
												color: '#23C290',
											},
										}}
										disabled={!IsDisabled}
									/>
								</div>
							))}
						</div>
					</div>
					<div className='TiposCuidado'>
						{
							<TipoServiciosEmpresaAdmin
								CategoriasPosibles={CategoriasPosibles}
								ServiciosPosibles={ServiciosPosibles}
								setServiciosPosibles={setServiciosPosibles}
								cambiarEstadoServ={cambiarEstadoServ}
								IsDisabled={!IsDisabled}
							/>
						}
					</div>
				</div>

				<div className='buttonGuardar'>
					<div
						className='button'
						Id='buttonGuardarFormUsu'
						onClick={comprobarDatos}
					>
						<b>Guardar cambios</b>
					</div>
					<div
						className='button borrarCuenta'
						Id='button buttonBorrarFormUsu'
						onClick={borrarCuenta}
					>
						<b>Borrar Usuario</b>
					</div>
				</div>
			</div>
			<Modal
				centered={true}
				isOpen={ModalErrores}
			>
				<ModalHeader>
					<b>Datos del formulario de registro inválidos</b>
				</ModalHeader>
				<ModalBody>
					<div>
						{ErroresFormulario.map((error) => (
							<div> - {error} </div>
						))}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='button-modal-registroEmpresa centrador'>
						<div
							className='button'
							onClick={() => {
								setModalErrores(false);
								setErroresFormulario([]);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
